// src/components/ui/MostrarProducto.jsx
import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import AsignarOfertaModal from './AsignarOfertaModal';

/* helpers locales para URL */
const resolveApiBase = () => {
  const env = (process.env.REACT_APP_API_BASE || '').trim();
  if (env) return env.replace(/\/+$/, '');
  const isLocal = ['localhost','127.0.0.1'].includes(window.location.hostname);
  return (isLocal ? 'http://localhost:5001' : window.location.origin).replace(/\/+$/, '');
};
const API_BASE = resolveApiBase();
const fileUrl = (p) => {
  if (!p) return '/nodisponible.png';
  const s = String(p).trim();
  if (/^https?:\/\//i.test(s) || s.startsWith('data:')) return s;
  return `${API_BASE}${s.startsWith('/') ? s : '/uploads/' + s}`;
};
const fmt = (n) => `Q ${Number(n || 0).toFixed(2)}`;

export default function MostrarProducto({ producto }) {
  const { id, imagen, nombre, marca, presentacion, precio, stock, estado } = producto;
  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false);

  const stockBajo = Number(stock ?? 0) < 10;
  const imagenSrc = useMemo(() => (imagen ? fileUrl(imagen) : '/nodisponible.png'), [imagen]);

  const irAVistaDetalle = (e) => {
    e?.stopPropagation?.();
    navigate(`/admin/producto/${id}`);
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm hover:shadow-md transition">
      <div className="aspect-[4/3] rounded-xl overflow-hidden bg-white border">
        <img
          src={imagenSrc}
          alt={nombre || 'Producto'}
          className="w-full h-full object-cover"
          onError={(e) => { e.currentTarget.src = '/nodisponible.png'; }}
        />
      </div>

      <div className="mt-3 flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="text-base font-bold text-slate-800 truncate" title={nombre}>{nombre || '—'}</div>
          <div className="text-sm text-slate-500 truncate">{marca || '—'} · {presentacion || '—'}</div>
        </div>
        <div className="text-right">
          <div className="text-lg font-extrabold">{fmt(precio)}</div>
          <div className="mt-1">
            <span
              className={`text-xs px-2 py-0.5 rounded-full border ${
                stockBajo ? 'bg-rose-100 text-rose-700 border-rose-200'
                          : 'bg-emerald-50 text-emerald-700 border-emerald-200'
              }`}
              title={`Stock: ${stock ?? 0}`}
            >
              Stock {stock ?? 0}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-2">
        <span className={`text-[11px] px-2 py-0.5 rounded-full border
          ${estado === 'disponible'
            ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
            : 'bg-slate-100 text-slate-700 border-slate-200'}`}>
          {estado || '—'}
        </span>
      </div>

      <div className="mt-4 flex gap-2">
        <button
          type="button"
          onClick={irAVistaDetalle}
          className="px-3 py-2 rounded-xl bg-sky-600 hover:bg-sky-700 text-white text-sm"
          title="Editar / Ver producto"
        >
          Ver producto
        </button>
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); setModalVisible(true); }}
          className="px-3 py-2 rounded-xl border border-slate-300 bg-white hover:bg-slate-50 text-sm"
        >
          Asignar oferta
        </button>
      </div>

      {modalVisible && (
        <AsignarOfertaModal
          producto={producto}
          setModalVisible={setModalVisible}
        />
      )}
    </div>
  );
}
